<template>
    <DadosFinanceirosShared ref="dadosFinanceirosShared" :Edicao="Edicao" />
</template>

<script>
import DadosFinanceirosShared from '@/views/Cadastro/Shared/DadosFinanceiros.vue'

export default {
    name: 'CadastroPF_DadosFinanceiros',
    components: { DadosFinanceirosShared },
    props: ['Edicao'],
    methods: {
        proximaEtapa() {
            if (this.$refs.dadosFinanceirosShared?.proximaEtapa) {
                this.$refs.dadosFinanceirosShared.proximaEtapa();
            }
        },
        validarFormulario(submeter) {
            if (this.$refs.dadosFinanceirosShared?.validarFormulario) {
                return this.$refs.dadosFinanceirosShared.validarFormulario(submeter);
            }
            return false;
        },
        salvarInformacoes() {
            if (this.$refs.dadosFinanceirosShared?.salvarInformacoes) {
                this.$refs.dadosFinanceirosShared.salvarInformacoes();
            }
        }
    }
}
</script>
